<template lang="pug">
  .curriculum-step-view
    video-thumbnail-detail(
      v-if="step.video.thumbnailUrl"
      :src="step.video.thumbnailUrl"
      :videoUrl="step.video.videoUrl"
      @click="$emit('click', $event);"
    )

    .curriculum-step-description
      step-badge(:number="number" class="step-badge")

      multiline-text-view(
        v-if="step.description"
        :text="step.description"
        class="multiline-text-view"
      )
</template>

<style lang="scss" scoped>
.curriculum-step-view {
  .curriculum-step-description {
    margin-top: 20px;
    display: flex;

    .multiline-text-view {
      flex: 1;
      margin: 0;
      padding: 0 0 0 12px;
    }
  }
}
</style>

<script>
import VideoThumbnailDetail from '@/components/atoms/VideoThumbnailDetail'
import StepBadge from '@/components/atoms/StepBadge'
import MultilineTextView from '@/components/molecules/MultilineTextView'

export default {
  props: {
    step: { type: Object, required: true },
    number: { type: Number, default: 1 },
  },
  components: { VideoThumbnailDetail, MultilineTextView, StepBadge },
}
</script>
